<template>
<div class="BranchJP">
    <div class="chuyen sang page">
        <h4>Mời quý khách ghé thăm trang page để xem được chi tiết cụ thể: <a href="https://www.facebook.com/pg/vanchuyenmaiphuong" target="blank"> https://www.facebook.com/pg/vanchuyenmaiphuong </a> </h4>
    </div>
     <div class="thong-tin" >
       <h3 style="margin-left:10px">Bảng giá vận chuyển</h3>
     </div>
    <div>
        <img :src="imgBangGia" alt="vanchuyenmaiphuong"/>
    </div>
    <div class="thong-tin col-md-12" >
       <h3>Liên hệ</h3>
     </div>
    <div class="col-md-12 thong-tin-lien-he"  style="margin-bottom:4em;text-align:left !important">
      <h4 style="color: blue;white-space:pre-line">FanPage Vận chuyển: <a href="https://www.facebook.com/pg/vanchuyenmaiphuong" target="blank"> Page Công ty vận chuyển >> click</a> </h4>
      <h4 style="color: blue;white-space:pre-line">FanPage Hàng nhật: <a href="https://www.facebook.com/HangChuanNhatMaiPhuongTokyo" target="blank">Page Hàng Nhật >> click</a> </h4>
      <h4 style="color: blue;white-space:pre-line">Zalo: (+81)9029111390 </h4>
      <h4 style="color: red;white-space:pre-line"> Email: maiphuong.tokyo@gmail.com </h4>
    </div>
</div>
</template>

<script>


export default {
    name: 'NewPage',
    data(){
        return{
            imgBangGia:"https://i.pinimg.com/originals/9e/d1/45/9ed14520c5670d70b8a77b7badceedb3.jpg",

        }
    }
}
</script>
<style scoped>
.BranchJP{
    margin-top: 160px;
    text-align: center;
    margin-left: 30px;
    margin-right: 30px;
}
.thong-tin{
    text-align: left !important;
  border-radius: 25px 0px 0px 25px;
  background-color: #34baeb;
  color: white;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-bottom: 1em;
  margin-top: 1em;
}
</style>